import { render, staticRenderFns } from "./BlogAllBooksPage.vue?vue&type=template&id=4bc6eead"
import script from "./BlogAllBooksPage.vue?vue&type=script&lang=js"
export * from "./BlogAllBooksPage.vue?vue&type=script&lang=js"
import style0 from "./BlogAllBooksPage.vue?vue&type=style&index=0&id=4bc6eead&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports